interface DefensePoint {
  icon: string;
  title: string;
  desc: string;
}

interface PracticeAreaSectionProps {
  id: string;
  icon: string;
  title: string;
  subtitle: string;
  description: string;
  points: DefensePoint[];
  reversed?: boolean;
  image: string;
}

export default function PracticeAreaSection({
  id,
  icon,
  title,
  subtitle,
  description,
  points,
  reversed = false,
  image,
}: PracticeAreaSectionProps) {
  return (
    <section id={id} className="py-20 scroll-mt-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section label */}
        <div className="flex items-center gap-3 mb-10">
          <div className="w-10 h-10 flex items-center justify-center bg-[#c9a84c]/10 border border-[#c9a84c]/25 rounded-xl">
            <i className={`${icon} text-[#c9a84c] text-lg`} />
          </div>
          <div>
            <span className="text-[#c9a84c] text-xs font-bold tracking-[0.18em] uppercase">{subtitle}</span>
            <h2
              className="text-2xl font-black text-[#070c14] leading-tight mt-0.5"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              {title}
            </h2>
          </div>
        </div>

        <div className={`flex flex-col lg:flex-row gap-12 items-start ${reversed ? 'lg:flex-row-reverse' : ''}`}>
          {/* Image */}
          <div className="lg:w-2/5 flex-shrink-0">
            <div className="w-full h-72 rounded-2xl overflow-hidden">
              <img
                src={image}
                alt={title}
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Content */}
          <div className="lg:w-3/5">
            <p className="text-[#3a4a5c] text-base leading-relaxed mb-8">{description}</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {points.map((pt) => (
                <div
                  key={pt.title}
                  className="flex items-start gap-3 p-4 rounded-xl bg-[#f8f5ef]/70 border border-[#c9a84c]/12"
                >
                  <div className="w-8 h-8 flex items-center justify-center bg-[#c9a84c]/10 rounded-lg flex-shrink-0 mt-0.5">
                    <i className={`${pt.icon} text-[#c9a84c] text-sm`} />
                  </div>
                  <div>
                    <p className="text-[#070c14] font-semibold text-sm mb-0.5">{pt.title}</p>
                    <p className="text-[#3a4a5c] text-xs leading-relaxed">{pt.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
